import { Link, useParams, Navigate } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Motion";
import { CtaBand } from "../components/CtaBand";
import { useLang } from "../i18n/LanguageContext";
import { SITE_URL, LOGO_URL } from "../data/content";

export default function BlogPost() {
  const { slug } = useParams();
  const { t, data } = useLang();
  const b = t.blog;
  const post = data.BLOG_POSTS.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.excerpt,
    image: post.image,
    datePublished: post.date,
    url: `${SITE_URL}/blog/${post.slug}`,
    author: { "@type": "Organization", name: "SG Language Services LLC", logo: LOGO_URL },
    publisher: { "@type": "Organization", name: "SG Language Services LLC", logo: { "@type": "ImageObject", url: LOGO_URL } }
  };

  return (
    <>
      <Seo title={`${post.title} | SG Language Services LLC`} description={post.excerpt} path={`/blog/${post.slug}`} schema={schema} />
      <article className="max-w-3xl mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-28" data-testid={`blog-post-${post.slug}`}>
        <nav className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted2 mb-8" aria-label="Breadcrumb">
          <Link to="/blog" className="hover:text-periwinkle-deep transition-colors duration-300">Blog</Link>
          <span className="mx-2">/</span>
          <span>{post.date}</span>
        </nav>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.05] tracking-tight">{post.title}</h1>
        <p className="mt-6 text-lg text-muted2 leading-relaxed">{post.excerpt}</p>
        <div className="mt-12 rounded-lg overflow-hidden border-8 border-white shadow-xl">
          <img src={post.image} alt={post.title} className="w-full h-72 sm:h-96 object-cover" />
        </div>
        <div className="mt-14 space-y-12">
          {post.sections.map((s, i) => (
            <Reveal key={i} delay={0.05}>
              <h2 className="font-serif text-2xl sm:text-3xl font-semibold">{s.h}</h2>
              <p className="mt-4 text-muted2 leading-relaxed">{s.p}</p>
            </Reveal>
          ))}
        </div>
        <div className="mt-16 border-t border-ink/10 pt-10">
          <p className="text-muted2">{b.needCta}</p>
          <Link to="/contact" data-testid="blog-post-cta" className="inline-block mt-3 link-underline font-semibold text-periwinkle-deep">{b.quoteLink}</Link>
        </div>
      </article>
      <CtaBand />
    </>
  );
}
